/* Artessa Wishlist — localStorage, no dependencies.
   Public API: window.ArtessaWishlist { list, has, count, toggle, remove } */
(function () {
  var KEY = 'artessa:wishlist';

  var available = (function () {
    try {
      var t = 'artessa:wl-test';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  })();
  if (!available) document.documentElement.setAttribute('data-wishlist-off', '');

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var saved = list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = saved
          ? btn.getAttribute('data-label-saved') || 'In your Wishlist'
          : btn.getAttribute('data-label-add') || 'Add to Wishlist';
      }
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      if (list.length === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
    document.dispatchEvent(new CustomEvent('artessa:wishlist:change', { detail: { list: list } }));
  }

  var api = {
    list: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    count: function () { return read().length; },
    toggle: function (h) {
      var list = read();
      var i = list.indexOf(h);
      if (i === -1) list.push(h); else list.splice(i, 1);
      write(list);
      sync();
      return i === -1;
    },
    remove: function (h) {
      var list = read();
      var i = list.indexOf(h);
      if (i !== -1) { list.splice(i, 1); write(list); sync(); }
    }
  };

  /* Capture phase so hearts inside card links toggle instead of navigating. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn || !available) return;
    e.preventDefault();
    e.stopPropagation();
    api.toggle(btn.getAttribute('data-wishlist-toggle'));
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  window.ArtessaWishlist = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
